import ComplaintAction from "./complaint.types";


export const complaintAddInStart = (complaint) => ({
  type: ComplaintAction.COMPLAINT_START,
  payload: complaint,
});

export const complaintAddInSuccess = (complaint) => ({
  type: ComplaintAction.COMPLAINT_SUCCESS,
  payload: complaint,
});

export const complaintAddInFailure = (error) => ({
  type: ComplaintAction.COMPLAINT_FAILURE,
  payload: error,
});
